module.exports = __webpack_public_path__ + "img/lacoste_content_img_02.d668e346.jpg";